import { createSlice } from "@reduxjs/toolkit"

export const blogsSlice = createSlice({
  name: 'blogs',
  initialState: {
    pinned: {
      total: 0,
      data: []
    },
    list: {
      total: 0,
      data: []
    },
    featured: {
      total: 0,
      data: []
    },
  },
  reducers: {
    getBlogsList: (state, action) => {
      return {
        ...state,
        list: action?.payload
      }
    },
    getPinnedBlogsList: (state, action) => {
      return {
        ...state,
        pinned: action?.payload
      }
    },
    getFeaturedBlogsList: (state, action) => {
      return {
        ...state,
        featured: action?.payload
      }
    },
  }
})

export const {
  getBlogsList,
  getPinnedBlogsList,
  getFeaturedBlogsList
} = blogsSlice.actions

export default blogsSlice.reducer

